import { render, staticRenderFns } from "./certificateLineSettings.vue?vue&type=template&id=8a746558&scoped=true&"
import script from "./certificateLineSettings.vue?vue&type=script&lang=js&"
export * from "./certificateLineSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a746558",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
